document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.product-faq-container');
    if (!container) return;

    // --- Tab Functionality ---
    const tabs = container.querySelectorAll('.faq-tab');
    const groups = container.querySelectorAll('.faq-category-group');

    if (tabs.length > 0 && groups.length > 0) {
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const cat = this.dataset.cat;
          tabs.forEach(t => t.classList.remove('active'));
          groups.forEach(g => g.classList.remove('active'));
          this.classList.add('active');
          const targetGroup = container.querySelector(`.faq-category-group[data-cat="${cat}"]`);
          if (targetGroup) {
            targetGroup.classList.add('active');
          }
        });
      });
    }

    // --- NEW: Accordion Functionality ---
    const questions = container.querySelectorAll('.faq-question');
    questions.forEach(function(question) {
      question.addEventListener('click', function() {
        // Find the parent .faq-item and toggle the .open class
        this.parentElement.classList.toggle('open');
      });
    });
  });